const urlVideoById = (url: string, loop: boolean = true, audio?: boolean) => {
  let videoId = '';

  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const vimeoRegex = /vimeo\.com\/(?:.+\/)?(\d+)/;

  const youtubeMatch = url.match(youtubeRegex);
  if (youtubeMatch) {
    videoId = youtubeMatch[1];
    return `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&rel=0&controls=0&showinfo=0&disablekb=1&loop=${+loop}&autohide=1&autoplay=1&mute=${+!audio}`;
  }
  
  const vimeoMatch = url.match(vimeoRegex);
  if (vimeoMatch) {
    videoId = vimeoMatch[1];
    return `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=${+loop}&title=0&byline=0&portrait=0&autopause=0&background=1&mute=${+!audio}`;
  }
}

export default urlVideoById;
